<app-modal-base
  [title]="'WelcomeToNickyWeAreHappyToHaveYou' | translate"
  [showCloseIcon]="true"
  [primaryButtonText]="'accept' | translate"
  [secondaryButtonText]="'decline' | translate"
  (close)="dialogRef.close(false)"
  (primaryClick)="dialogRef.close(true)"
  (secondaryClick)="dialogRef.close(false)"
>
  <p class="text-gray-600">
    {{ 'youNeedToAgreeWithThe' | translate }}
    <a [href]="termsOfUseUrl" target="_blank" class="text-blue-600 hover:text-blue-700 hover:underline">
      {{ 'REGISTER.termsOfUse' | translate }} </a
    >,
    <a [href]="cookiePolicyUrl" target="_blank" class="text-blue-600 hover:text-blue-700 hover:underline">
      {{ 'cookiePolicy' | translate }}
    </a>
    {{ 'REGISTER.and' | translate }}
    <a [href]="privacyPolicyUrl" target="_blank" class="text-blue-600 hover:text-blue-700 hover:underline">
      {{ 'privacyPolicy' | translate }}
    </a>
  </p>
</app-modal-base>
